import { __decorate, __metadata } from "tslib";
import { Component, Prop } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
import { ThemeColor } from "../../variables";
export const COMPONENT_NAME = "LvBadge";
/**
 * A badge component
 */
let LvBadge = class LvBadge extends UIComponent {
    get classList() {
        return [
            this.color,
            this.dot ? "dot" : null
        ].filter(x => x != null);
    }
};
__decorate([
    Prop({ type: String, required: false, default: "primary" }),
    __metadata("design:type", String)
], LvBadge.prototype, "color", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false }),
    __metadata("design:type", Boolean)
], LvBadge.prototype, "dot", void 0);
LvBadge = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvBadge);
export default LvBadge;
//# sourceMappingURL=script.js.map